<template>
  <div class="user-list-combox">
    <el-table :data="pageData.items" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column label="类型" width="100">
        <template slot-scope="scope">
          {{typeMap[scope.row.type]}}
        </template>
      </el-table-column>
      <el-table-column label="用户" width="100">
        <template slot-scope="scope">
          {{scope.row.user.nickname}}
        </template>
      </el-table-column>
      <el-table-column label="封面" width="200">
        <template slot-scope="scope">
          <img class="cover" v-if="scope.row.cover" :src="scope.row.cover" />
        </template>
      </el-table-column>
      <el-table-column prop="utime" label="时间" width="180" />
      <el-table-column prop="title" label="操作" width="100">
        <template slot-scope="scope">
          <span class="action" @click="preview(scope.row)">预览</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :total="pageData.amount" :page-size="pageData.pageSize" @current-change="handlePageChange" />
    </div>
    <el-dialog title="提示" :visible.sync="showPreview" width="60%">
      <div class="preview-content">
        <video v-if="currentItem.type === '4'" style="max-width: 600px" class="video-player" controls :destroy-on-close="true" :src="currentItem.path"></video>
        <el-row v-if="currentItem.type === '2'">
          <el-col :span="6" v-for="(item,index) in currentItem.path" :key="index">
            <el-image style="width: 100%; max-height: 200px" :src="item" fit="scale-down" :preview-src-list="currentItem.path"></el-image>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ParseListComponent',
  props: {
    pageData: {}
  },
  data () {
    return {
      ids: [],
      appMap: {
        wx1dc8ad85d20d02eb: '二货',
        wxb5c4c0d7adf90cbd: '去水印'
      },
      typeMap: {
        2: '图片',
        4: '视频'
      },
      currentItem: {},
      showPreview: false
    }
  },
  methods: {
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i]['id'])
      }
      this.$emit('onSelectChanged', ids)
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    },
    preview (data) {
      this.showPreview = true
      this.currentItem = data
      console.log(data)
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: center;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}

.cover {
  width: 150px;
}

.preview-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parse/ParseListComponent.vue